(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = require("prop-types");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var propTypes = {
  href: _propTypes.string,
  info: _propTypes.string,
  text: _propTypes.string.isRequired,
  type: _propTypes.string,
  size: _propTypes.string,
  theme: _propTypes.string,
  outline: _propTypes.bool,
  cssClass: _propTypes.string,
  handleClick: _propTypes.func
};

// ImageCTA is a stateless functional component.
var Button = function Button(props) {
  var href = props.href,
    info = props.info,
    text = props.text,
    _props$type = props.type,
    type = _props$type === void 0 ? "button" : _props$type,
    size = props.size,
    theme = props.theme,
    _props$outline = props.outline,
    outline = _props$outline === void 0 ? false : _props$outline,
    _props$cssClass = props.cssClass,
    cssClass = _props$cssClass === void 0 ? "" : _props$cssClass,
    handleClick = props.handleClick;
  var buttonSize = size ? "hl__button--".concat(size) : "";
  var buttonStyle = outline ? "hl__button--minor" : "";
  var buttonTheme = theme ? "hl__button--".concat(theme) : "";
  var buttonClass = "hl__button ".concat(buttonSize, " ").concat(buttonTheme, " ").concat(buttonStyle, " ").concat(cssClass);
  if (href) {
    return /*#__PURE__*/_react["default"].createElement("a", {
      href: href,
      className: buttonClass,
      title: info
    }, text);
  } else {
    return /*#__PURE__*/_react["default"].createElement("button", {
      type: type,
      className: buttonClass,
      "aria-label": info,
      onClick: handleClick
    }, text);
  }
};
Button.propTypes = propTypes; // defined at the top of the file
var _default = exports["default"] = Button;

},{"prop-types":"prop-types","react":"react"}],2:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = require("prop-types");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var propTypes = {
  label: _propTypes.string,
  onChange: _propTypes.func.isRequired,
  activeFilter: _propTypes.string,
  items: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
    name: _propTypes.string.isRequired,
    value: _propTypes.string.isRequired,
    label: _propTypes.string.isRequired
  })).isRequired
};
var FilterByType = function FilterByType(props) {
  var handleChange = function handleChange(event) {
    props.onChange(event.target.value);
  };
  var renderFilters = function renderFilters(items) {
    return items.map(function (item) {
      return /*#__PURE__*/_react["default"].createElement("label", {
        key: item.value,
        className: "hl__radio-input"
      }, /*#__PURE__*/_react["default"].createElement("input", {
        name: item.name,
        "aria-label": item.name,
        type: "radio",
        value: item.value,
        checked: item.value === props.activeFilter,
        onChange: handleChange
      }), /*#__PURE__*/_react["default"].createElement("span", {
        className: "hl__radio-input__label"
      }, item.label));
    });
  };
  var label = props.label,
    items = props.items;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "hl__filter-by-type"
  }, /*#__PURE__*/_react["default"].createElement("fieldset", null, /*#__PURE__*/_react["default"].createElement("legend", null, label), /*#__PURE__*/_react["default"].createElement("span", {
    className: "hl__filter-by-type__label",
    "aria-hidden": true
  }, label), renderFilters(items)));
};
FilterByType.propTypes = propTypes; // defined at the top of the file
var _default = exports["default"] = FilterByType;

},{"prop-types":"prop-types","react":"react"}],3:[function(require,module,exports){
"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _button = _interopRequireDefault(require("../../01-atoms/buttons/button.jsx"));
var _propTypes = require("prop-types");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var propTypes = {
  action: _propTypes.string.isRequired,
  method: _propTypes.string,
  theme: _propTypes.string.isRequired,
  helperText: _propTypes.string,
  button: _propTypes.object.isRequired,
  onSubmit: _propTypes.func.isRequired,
  onChange: _propTypes.func.isRequired,
  searchTerm: _propTypes.string
};
var SingleInputForm = function SingleInputForm(props) {
  var handleSubmit = function handleSubmit(event) {
    event.preventDefault();
    props.onSubmit();
  };
  var handleChange = function handleChange(event) {
    props.onChange(event.target.value);
  };
  var searchTerm = props.searchTerm,
    action = props.action,
    method = props.method,
    theme = props.theme,
    helperText = props.helperText,
    button = props.button;
  var themeClass = theme ? "hl__single-input-form--".concat(theme) : "";
  return /*#__PURE__*/_react["default"].createElement("section", {
    className: "hl__single-input-form " + themeClass
  }, /*#__PURE__*/_react["default"].createElement("form", {
    className: "hl__single-input-form__form",
    action: action,
    method: method,
    onSubmit: handleSubmit
  }, /*#__PURE__*/_react["default"].createElement("label", {
    className: "hl__label hl__label--hidden",
    htmlFor: "search-page-keyword"
  }, "Enter a keyword to search"), helperText && /*#__PURE__*/_react["default"].createElement("div", {
    className: "hl__single-input-form__helper-text"
  }, helperText), /*#__PURE__*/_react["default"].createElement("div", {
    className: "hl__single-input-form__input-group"
  }, /*#__PURE__*/_react["default"].createElement("input", {
    className: "hl__input hl__input--inline",
    name: "keyword",
    id: "search-page-keyword",
    type: "text",
    placeholder: "Keyword Search",
    value: searchTerm,
    onChange: handleChange
  }), /*#__PURE__*/_react["default"].createElement(_button["default"], button))));
};
SingleInputForm.propTypes = propTypes; // defined at the top of the file
var _default = exports["default"] = SingleInputForm;

},{"../../01-atoms/buttons/button.jsx":1,"prop-types":"prop-types","react":"react"}],4:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactInlinesvg = _interopRequireDefault(require("react-inlinesvg"));
var _button = _interopRequireDefault(require("../../01-atoms/buttons/button.jsx"));
var _propTypes = require("prop-types");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var propTypes = {
  compHeading: (0, _propTypes.shape)({
    text: _propTypes.string.isRequired
  }).isRequired,
  theme: _propTypes.string,
  icon: _propTypes.string.isRequired,
  description: _propTypes.string.isRequired,
  button: _propTypes.object.isRequired
};
var iconPromo = function iconPromo(props) {
  var compHeading = props.compHeading,
    theme = props.theme,
    icon = props.icon,
    description = props.description,
    button = props.button;
  var themeClass = theme ? "hl__icon-promo--".concat(theme) : "";
  return /*#__PURE__*/_react["default"].createElement("section", {
    className: "hl__icon-promo ".concat(themeClass)
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "hl__icon-promo__container"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "hl__icon-promo__content"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "hl__icon-promo__icon",
    "aria-hidden": "true"
  }, /*#__PURE__*/_react["default"].createElement(_reactInlinesvg["default"], {
    src: icon
  })), /*#__PURE__*/_react["default"].createElement("h2", {
    className: "hl__comp-heading"
  }, compHeading.text), /*#__PURE__*/_react["default"].createElement("div", {
    className: "hl__icon-promo__text-action"
  }, /*#__PURE__*/_react["default"].createElement("p", {
    className: "hl__icon-promo__description"
  }, description), /*#__PURE__*/_react["default"].createElement("div", {
    className: "hl__icon-promo__action-container"
  }, /*#__PURE__*/_react["default"].createElement(_button["default"], button))))));
};
iconPromo.propTypes = propTypes; // defined at the top of the file
var _default = exports["default"] = iconPromo;

},{"../../01-atoms/buttons/button.jsx":1,"prop-types":"prop-types","react":"react","react-inlinesvg":"react-inlinesvg"}],5:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _jquery = _interopRequireDefault(require("jquery"));
var _propTypes = require("prop-types");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var LibraryCard = exports["default"] = /*#__PURE__*/function (_Component) {
  function LibraryCard() {
    _classCallCheck(this, LibraryCard);
    return _callSuper(this, LibraryCard, arguments);
  }
  _inherits(LibraryCard, _Component);
  return _createClass(LibraryCard, [{
    key: "renderHours",
    value: function renderHours(hours) {
      return hours.map(function (h, i) {
        return /*#__PURE__*/_react["default"].createElement("li", {
          key: i
        }, /*#__PURE__*/_react["default"].createElement("span", {
          className: "hl__library-card__hours-label"
        }, h.label), /*#__PURE__*/_react["default"].createElement("span", {
          className: "hl__library-card__hours-value"
        }, h.rendered));
      });
    }
  }, {
    key: "currentStatus",
    value: function currentStatus(today_hours) {
      return today_hours.currently_open ? "Open Now" : "Currently Closed";
    }
  }, {
    key: "buildAddress",
    value: function buildAddress(a) {
      return a.address_line2 ? "".concat(a.address_line1, "<br />").concat(a.address_line2) : a.address_line1;
    }
  }, {
    key: "render",
    value: function render() {
      var _this = this;
      var _this$props = this.props,
        address = _this$props.address,
        directions_link = _this$props.directions_link,
        hours_link = _this$props.hours_link,
        href = _this$props.href,
        id = _this$props.id,
        image = _this$props.image,
        name = _this$props.name,
        subTitle = _this$props.subTitle,
        timeLabel = _this$props.timeLabel,
        today_hours = _this$props.today_hours,
        external = _this$props.external;

      // const { expanded } = this.state;

      // department hours is the new API property (06-2018)
      var all_times = today_hours && today_hours.department_hours || this.props.all_times;

      // const accordionLabel = expanded ? "Hide Detailed Hours" : "Show Detailed Hours";

      return /*#__PURE__*/_react["default"].createElement("section", {
        className: "hl__library-card"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "hl__library-card__container-top"
      }, today_hours && today_hours.currently_open && /*#__PURE__*/_react["default"].createElement("div", {
        className: "hl__library-card__status"
      }, this.currentStatus(today_hours)), /*#__PURE__*/_react["default"].createElement("a", {
        className: "hl__library-card__image",
        href: href,
        "aria-label": "".concat(name, " details"),
        "aria-hidden": "true"
      }, /*#__PURE__*/_react["default"].createElement("img", {
        src: image.src,
        alt: image.alt,
        height: image.height,
        width: image.width
      })), /*#__PURE__*/_react["default"].createElement("div", {
        className: "hl__library-card__header"
      }, /*#__PURE__*/_react["default"].createElement("h2", {
        className: "hl__library-card__title"
      }, /*#__PURE__*/_react["default"].createElement("a", {
        href: href,
        "aria-label": "".concat(name, " details")
      }, name, external == true && /*#__PURE__*/_react["default"].createElement("span", {
        className: "hl__link-tag__external-icon"
      }, /*#__PURE__*/_react["default"].createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        width: "20",
        height: "20",
        viewBox: "0 0 20 20"
      }, /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("g", {
        transform: "translate(-906 -1005)"
      }, /*#__PURE__*/_react["default"].createElement("path", {
        d: "M923.78 1022.78V1015H926v7.78c0 1.22-1 2.22-2.22 2.22h-15.56c-1.23 0-2.22-1-2.22-2.22v-15.56c0-1.22.99-2.22 2.22-2.22H916v2.22h-7.78v15.56zm-5.71-17.78H926v7.93h-2.27v-4.07L912.6 1020l-1.6-1.6 11.14-11.13h-4.07z"
      }))))))), subTitle.length !== 0 && /*#__PURE__*/_react["default"].createElement("p", {
        className: "hl__library-card__sub-title"
      }, subTitle)), address && /*#__PURE__*/_react["default"].createElement("div", {
        className: "hl__library-card__address-container"
      }, /*#__PURE__*/_react["default"].createElement("span", {
        className: "hl__library-card__map-icon"
      }, /*#__PURE__*/_react["default"].createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, /*#__PURE__*/_react["default"].createElement("mask", {
        id: "mask0_4910_128236",
        maskUnits: "userSpaceOnUse",
        x: "0",
        y: "0",
        width: "24",
        height: "24"
      }, /*#__PURE__*/_react["default"].createElement("rect", {
        width: "24",
        height: "24",
        fill: "#D9D9D9"
      })), /*#__PURE__*/_react["default"].createElement("g", {
        mask: "url(#mask0_4910_128236)"
      }, /*#__PURE__*/_react["default"].createElement("path", {
        d: "M12 12C12.55 12 13.0208 11.8042 13.4125 11.4125C13.8042 11.0208 14 10.55 14 10C14 9.45 13.8042 8.97917 13.4125 8.5875C13.0208 8.19583 12.55 8 12 8C11.45 8 10.9792 8.19583 10.5875 8.5875C10.1958 8.97917 10 9.45 10 10C10 10.55 10.1958 11.0208 10.5875 11.4125C10.9792 11.8042 11.45 12 12 12ZM12 19.35C14.0333 17.4833 15.5417 15.7875 16.525 14.2625C17.5083 12.7375 18 11.3833 18 10.2C18 8.38333 17.4208 6.89583 16.2625 5.7375C15.1042 4.57917 13.6833 4 12 4C10.3167 4 8.89583 4.57917 7.7375 5.7375C6.57917 6.89583 6 8.38333 6 10.2C6 11.3833 6.49167 12.7375 7.475 14.2625C8.45833 15.7875 9.96667 17.4833 12 19.35ZM12 22C9.31667 19.7167 7.3125 17.5958 5.9875 15.6375C4.6625 13.6792 4 11.8667 4 10.2C4 7.7 4.80417 5.70833 6.4125 4.225C8.02083 2.74167 9.88333 2 12 2C14.1167 2 15.9792 2.74167 17.5875 4.225C19.1958 5.70833 20 7.7 20 10.2C20 11.8667 19.3375 13.6792 18.0125 15.6375C16.6875 17.5958 14.6833 19.7167 12 22Z",
        fill: "#202020"
      })))), address && directions_link && /*#__PURE__*/_react["default"].createElement("a", {
        href: directions_link,
        "aria-label": "get directions to ".concat(name),
        className: "hl__library-card__address-text"
      }, this.buildAddress(address), /*#__PURE__*/_react["default"].createElement("br", null), address.locality, ", ", address.administrative_area, " ", address.postal_code), address && !directions_link && /*#__PURE__*/_react["default"].createElement("span", {
        className: "hl__library-card__address-text"
      }, this.buildAddress(address), /*#__PURE__*/_react["default"].createElement("br", null), address.locality, ", ", address.administrative_area, " ", address.postal_code))), /*#__PURE__*/_react["default"].createElement("div", {
        className: "hl__library-card__container-bottom"
      }, today_hours && today_hours.rendered && /*#__PURE__*/_react["default"].createElement("div", {
        className: "hl__library-card__hours-container"
      }, /*#__PURE__*/_react["default"].createElement("span", {
        className: "hl__library-card__clock-icon"
      }, /*#__PURE__*/_react["default"].createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, /*#__PURE__*/_react["default"].createElement("mask", {
        id: "mask0_4910_126259",
        maskUnits: "userSpaceOnUse",
        x: "0",
        y: "0",
        width: "24",
        height: "24"
      }, /*#__PURE__*/_react["default"].createElement("rect", {
        width: "24",
        height: "24",
        fill: "#D9D9D9"
      })), /*#__PURE__*/_react["default"].createElement("g", {
        mask: "url(#mask0_4910_126259)"
      }, /*#__PURE__*/_react["default"].createElement("path", {
        d: "M11.9996 22C10.7496 22 9.57878 21.7625 8.48711 21.2875C7.39544 20.8125 6.44544 20.1708 5.63711 19.3625C4.82878 18.5541 4.18711 17.6041 3.71211 16.5125C3.23711 15.4208 2.99961 14.25 2.99961 13C2.99961 11.75 3.23711 10.5791 3.71211 9.48748C4.18711 8.39581 4.82878 7.44581 5.63711 6.63748C6.44544 5.82914 7.39544 5.18748 8.48711 4.71248C9.57878 4.23748 10.7496 3.99998 11.9996 3.99998C13.2496 3.99998 14.4204 4.23748 15.5121 4.71248C16.6038 5.18748 17.5538 5.82914 18.3621 6.63748C19.1704 7.44581 19.8121 8.39581 20.2871 9.48748C20.7621 10.5791 20.9996 11.75 20.9996 13C20.9996 14.25 20.7621 15.4208 20.2871 16.5125C19.8121 17.6041 19.1704 18.5541 18.3621 19.3625C17.5538 20.1708 16.6038 20.8125 15.5121 21.2875C14.4204 21.7625 13.2496 22 11.9996 22ZM14.7996 17.2L16.1996 15.8L12.9996 12.6V7.99998H10.9996V13.4L14.7996 17.2ZM5.59961 2.34998L6.99961 3.74998L2.74961 7.99998L1.34961 6.59998L5.59961 2.34998ZM18.3996 2.34998L22.6496 6.59998L21.2496 7.99998L16.9996 3.74998L18.3996 2.34998ZM11.9996 20C13.9496 20 15.6038 19.3208 16.9621 17.9625C18.3204 16.6041 18.9996 14.95 18.9996 13C18.9996 11.05 18.3204 9.39581 16.9621 8.03748C15.6038 6.67914 13.9496 5.99998 11.9996 5.99998C10.0496 5.99998 8.39544 6.67914 7.03711 8.03748C5.67878 9.39581 4.99961 11.05 4.99961 13C4.99961 14.95 5.67878 16.6041 7.03711 17.9625C8.39544 19.3208 10.0496 20 11.9996 20Z",
        fill: "#202020"
      })))), /*#__PURE__*/_react["default"].createElement("span", {
        className: "hl__library-card__hours-text"
      }, "Today, ", today_hours.rendered)), all_times && all_times.length > 0 && /*#__PURE__*/_react["default"].createElement("div", {
        className: "hl__library-card__more-hours"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        ref: function ref(el) {
          return _this.accordionContent = el;
        },
        className: "hl__library-card__hours-content",
        id: "hours-content-".concat(id)
      }, /*#__PURE__*/_react["default"].createElement("p", null, /*#__PURE__*/_react["default"].createElement("span", {
        className: "hl__library-card__today"
      }, timeLabel)), /*#__PURE__*/_react["default"].createElement("ul", {
        className: "hl__library-card__hours-list"
      }, this.renderHours(all_times))), /*#__PURE__*/_react["default"].createElement("div", {
        className: "hl__library-card__hours-link"
      }, /*#__PURE__*/_react["default"].createElement("a", {
        className: "hl__link-tag hl__link-tag--with-arrow",
        href: hours_link,
        "aria-label": "see all hours for ".concat(name)
      }, /*#__PURE__*/_react["default"].createElement("span", null, "See All Hours"))))));
    }
  }]);
}(_react.Component);
_defineProperty(LibraryCard, "propTypes", {
  address: (0, _propTypes.shape)({
    address_line1: _propTypes.string,
    address_line2: _propTypes.string,
    locality: _propTypes.string,
    administrative_area: _propTypes.string,
    postal_code: _propTypes.string
  }),
  all_times: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
    label: _propTypes.string,
    rendered: _propTypes.string
  })),
  directions_link: _propTypes.string,
  hours_link: _propTypes.string.isRequired,
  href: _propTypes.string.isRequired,
  id: _propTypes.string.isRequired,
  image: (0, _propTypes.shape)({
    src: _propTypes.string.isRequired,
    alt: _propTypes.string,
    height: _propTypes.string,
    width: _propTypes.string
  }),
  name: _propTypes.string.isRequired,
  subTitle: _propTypes.string,
  timeLabel: _propTypes.string,
  today_hours: (0, _propTypes.shape)({
    status: _propTypes.string.isRequired,
    rendered: _propTypes.string.isRequired,
    currently_open: _propTypes.bool,
    department_hours: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
      label: _propTypes.string,
      rendered: _propTypes.string
    }))
  }),
  external: _propTypes.bool.isRequired
});

},{"jquery":"jquery","prop-types":"prop-types","react":"react"}],6:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = require("prop-types");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var propTypes = {
  title: _propTypes.string.isRequired,
  href: _propTypes.string.isRequired,
  type: _propTypes.string,
  publisher: _propTypes.string,
  author: _propTypes.string,
  isPartOf: _propTypes.string,
  link: (0, _propTypes.shape)({
    href: _propTypes.string.isRequired,
    text: _propTypes.string.isRequired
  }).isRequired,
  additionaLink: (0, _propTypes.shape)({
    href: _propTypes.string.isRequired,
    text: _propTypes.string.isRequired
  })
};

// SearchResultItem is a stateless functional component.
var SearchResultItem = function SearchResultItem(props) {
  var renderTitle = function renderTitle(title, link) {
    if (link) {
      return /*#__PURE__*/_react["default"].createElement("a", {
        href: link
      }, title);
    } else {
      return title;
    }
  };
  var title = props.title,
    href = props.href,
    type = props.type,
    publisher = props.publisher,
    author = props.author,
    isPartOf = props.isPartOf,
    link = props.link,
    additionaLink = props.additionaLink;
  return /*#__PURE__*/_react["default"].createElement("section", {
    className: "hl__search-result-item"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "hl__search-result-item__text"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "hl__search-result-item__type"
  }, type), /*#__PURE__*/_react["default"].createElement("h4", {
    className: "hl__search-result-item__title"
  }, renderTitle(title, href)), author && /*#__PURE__*/_react["default"].createElement("div", {
    className: "hl__search-result-item__author"
  }, author), publisher && /*#__PURE__*/_react["default"].createElement("div", {
    className: "hl__search-result-item__publisher"
  }, publisher), isPartOf && /*#__PURE__*/_react["default"].createElement("div", {
    className: "hl__search-result-item__is-part-of"
  }, isPartOf), additionaLink && /*#__PURE__*/_react["default"].createElement("div", {
    className: "hl__search-result-item__link"
  }, /*#__PURE__*/_react["default"].createElement("a", {
    href: additionaLink.href,
    className: "hl__link-tag"
  }, additionaLink.text))));
};
SearchResultItem.propTypes = propTypes; // defined at the top of the file
var _default = exports["default"] = SearchResultItem;

},{"prop-types":"prop-types","react":"react"}],7:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = require("prop-types");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var propTypes = {
  featuredImages: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
    title: _propTypes.string.isRequired,
    id: _propTypes.string.isRequired,
    thumbnail: _propTypes.string,
    link: (0, _propTypes.shape)({
      href: _propTypes.string.isRequired,
      text: _propTypes.string
    }).isRequired
  })),
  totalImages: _propTypes.number.isRequired,
  seeMoreLink: _propTypes.string
};
var FeaturedImageList = function FeaturedImageList(props) {
  var renderImages = function renderImages(featuredImages) {
    return featuredImages.map(function (image) {
      var style = {
        backgroundImage: "url(\"".concat(image.thumbnail, "\")")
      };
      return /*#__PURE__*/_react["default"].createElement("a", {
        key: image.id,
        className: "hl__featured-image-list__image",
        href: image.link.href,
        title: image.title,
        style: style
      }, /*#__PURE__*/_react["default"].createElement("img", {
        src: image.thumbnail,
        alt: image.title
      }));
    });
  };
  var featuredImages = props.featuredImages,
    totalImages = props.totalImages,
    seeMoreLink = props.seeMoreLink;
  return /*#__PURE__*/_react["default"].createElement("section", {
    className: "hl__featured-image-list"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "hl__featured-image-list__images"
  }, renderImages(featuredImages)), /*#__PURE__*/_react["default"].createElement("div", {
    className: "hl__featured-image-list__footer"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "hl__featured-image-list__count"
  }, /*#__PURE__*/_react["default"].createElement("b", null, featuredImages.length), " of ", /*#__PURE__*/_react["default"].createElement("b", null, totalImages), " Images"), /*#__PURE__*/_react["default"].createElement("div", {
    className: "hl__featured-image-list__see-more"
  }, seeMoreLink && /*#__PURE__*/_react["default"].createElement("a", {
    className: "hl__link-tag hl__link-tag--with-arrow ",
    href: seeMoreLink,
    title: ""
  }, /*#__PURE__*/_react["default"].createElement("span", null, "More images from hollis")))));
};
FeaturedImageList.propTypes = propTypes; // defined at the top of the file
var _default = exports["default"] = FeaturedImageList;

},{"prop-types":"prop-types","react":"react"}],8:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _searchResultItem = _interopRequireDefault(require("../../02-molecules/text/search-result-item.jsx"));
var _propTypes = require("prop-types");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var propTypes = {
  results: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
    id: _propTypes.string.isRequired
  }))
};
var ResultsList = function ResultsList(props) {
  var renderResults = function renderResults(results) {
    return results.map(function (result) {
      return /*#__PURE__*/_react["default"].createElement(_searchResultItem["default"], _extends({
        key: result.id
      }, result));
    });
  };
  return /*#__PURE__*/_react["default"].createElement("section", {
    className: "hl__results-list"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "hl__results-list__container"
  }, renderResults(props.results)));
};
ResultsList.propTypes = propTypes; // defined at the top of the file
var _default = exports["default"] = ResultsList;

},{"../../02-molecules/text/search-result-item.jsx":6,"prop-types":"prop-types","react":"react"}],9:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _jquery = _interopRequireDefault(require("jquery"));
var _react = _interopRequireWildcard(require("react"));
var _queryString = _interopRequireDefault(require("query-string"));
var _resultsList = _interopRequireDefault(require("../../03-organisms/lists/results-list.jsx"));
var _propTypes = require("prop-types");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var SearchListingApp = exports["default"] = /*#__PURE__*/function (_Component) {
  function SearchListingApp(props) {
    var _this;
    _classCallCheck(this, SearchListingApp);
    _this = _callSuper(this, SearchListingApp, [props]);
    _defineProperty(_this, "componentDidMount", function () {
      var searchTerm = _this.state.searchTerm;
      if (searchTerm.length > 0) {
        _this.getData(searchTerm);
      }
    });
    _defineProperty(_this, "getData", function (keyword) {
      // Hollis everything results
      _this.getHollisData(keyword).done(function (data) {
        var results = data;
        if (typeof results["docs"] === "undefined") {
          _this.setState({
            hollisResults: []
          });
          return;
        }
        var totalHits = parseInt(results["info"]["total"]);
        _this.setState({
          hollisResults: totalHits
        });
      }).fail(function (xhr, status, error) {
        _this.setState({
          hollisResults: []
        });
      });
    });
    _defineProperty(_this, "getHollisData", function (keyword) {
      var baseRequestUrl = _this.props.baseRequestUrl;
      var query = "q=any,contains," + encodeURIComponent(keyword);
      var queryUrl = "".concat(baseRequestUrl, "?").concat(query, "&tab=everything&scope=everything");
      return _jquery["default"].ajax({
        url: queryUrl,
        data: null,
        timeout: 10000,
        dataType: "json"
      });
    });
    _this.state = {
      searchTerm: _queryString["default"].parse(location.search).keywords || "",
      hollisResults: []
    };
    return _this;
  }
  _inherits(SearchListingApp, _Component);
  return _createClass(SearchListingApp, [{
    key: "render",
    value: function render() {
      var hollisResults = this.state.hollisResults;
      return /*#__PURE__*/_react["default"].createElement("span", {
        className: "hl__search-directory__hollis-results"
      }, "Search HOLLIS catalog ", /*#__PURE__*/_react["default"].createElement("span", null, "(", hollisResults, " results)"));
    }
  }]);
}(_react.Component);
_defineProperty(SearchListingApp, "propTypes", {
  baseRequestUrl: _propTypes.string.isRequired
});

},{"../../03-organisms/lists/results-list.jsx":8,"jquery":"jquery","prop-types":"prop-types","query-string":"query-string","react":"react"}],10:[function(require,module,exports){
"use strict";

var _react = _interopRequireDefault(require("react"));
var _reactDom = require("react-dom");
var _searchDirectoryApp = _interopRequireDefault(require("./search-directory-app.jsx"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var el = document.querySelector(".js-search-directory-app");
if (el) {
  var props = {
    baseRequestUrl: el.getAttribute("data-request-url")
  };
  (0, _reactDom.render)(/*#__PURE__*/_react["default"].createElement(_searchDirectoryApp["default"], props), el);
}

},{"./search-directory-app.jsx":9,"react":"react","react-dom":"react-dom"}],11:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _jquery = _interopRequireDefault(require("jquery"));
var _react = _interopRequireWildcard(require("react"));
var _queryString = _interopRequireDefault(require("query-string"));
var _button = _interopRequireDefault(require("../../01-atoms/buttons/button.jsx"));
var _singleInputForm = _interopRequireDefault(require("../../02-molecules/forms/single-input-form.jsx"));
var _filterByType = _interopRequireDefault(require("../../02-molecules/forms/filter-by-type.jsx"));
var _libraryCard = _interopRequireDefault(require("../../02-molecules/teasers/library-card.jsx"));
var _iconPromo = _interopRequireDefault(require("../../02-molecules/teasers/icon-promo.jsx"));
var _resultsList = _interopRequireDefault(require("../../03-organisms/lists/results-list.jsx"));
var _featuredImageList = _interopRequireDefault(require("../../03-organisms/lists/featured-image-list.jsx"));
var _propTypes = require("prop-types");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var SearchListingApp = exports["default"] = /*#__PURE__*/function (_Component) {
  function SearchListingApp() {
    var _this;
    _classCallCheck(this, SearchListingApp);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, SearchListingApp, [].concat(args));
    _defineProperty(_this, "state", {
      queryString: _queryString["default"].parse(location.search),
      searchTerm: _queryString["default"].parse(location.search).keyword || "",
      requestedSearchTerm: _queryString["default"].parse(location.search).keyword || "",
      searchTermDisplay: "",
      totalHollisResults: 0,
      totalImages: 0,
      totalOnlineArticles: 0,
      featuredImages: [],
      featuredLibrary: _this.props.featuredLibrary || null,
      hollisResults: [],
      onlineArticles: [],
      activeTabIndex: "0",
      filters: {
        label: "Show Me:",
        items: [{
          name: "search-tabs",
          value: "0",
          label: "HOLLIS"
        }, {
          name: "search-tabs",
          value: "1",
          label: "Online Articles"
        }, {
          name: "search-tabs",
          value: "2",
          label: "Site Search Results"
        }]
      }
    });
    _defineProperty(_this, "componentDidMount", function () {
      var searchTerm = _this.state.searchTerm;
      if (searchTerm.length > 0) {
        _this.getData(searchTerm);
      }
      if (!_this.state.featuredLibrary) {
        _this.getFeaturedLibrary("131").done(function (data) {
          _this.setState({
            featuredLibrary: data[0]
          });
        }).fail(function (xhr, status, error) {
          if (window.harvardLibrary.featuredLibrary) {
            console.warn("using static featured library");
            _this.setState({
              featuredLibrary: window.harvardLibrary.featuredLibrary
            });
          } else {
            console.error("failed to fetch featured library");
            _this.setState({
              featuredLibrary: null
            });
          }
        });
      }
      _this.initializeGoogleSearch();
    });
    _defineProperty(_this, "initializeGoogleSearch", function () {
      var $el = (0, _jquery["default"])("#hl__google-cse-results");
      // adding Google Custom Search code
      $el.html("<gcse:searchresults-only gname=\"google_cse\" queryParameterName=\"keyword\"></gcse:searchresults-only>");
      var cx = "002386710524587861402:bhhhefxf6ki";
      var gcse = document.createElement("script");
      gcse.type = "text/javascript";
      gcse.async = true;
      gcse.src = "https://cse.google.com/cse.js?cx=" + cx;
      var s = document.getElementsByTagName("script")[0];
      s.parentNode.insertBefore(gcse, s);
      $el.on("click", ".gsc-url-bottom .gs-visibleUrl", function () {
        var url = (0, _jquery["default"])(this).closest(".gs-result").find("a.gs-title").first().attr("href");
        if (url) {
          window.location.href = url;
        }
      });
    });
    _defineProperty(_this, "resetSearch", function () {
      _this.setState({
        searchTerm: "",
        onlineArticles: [],
        hollisResults: [],
        featuredImages: [],
        totalHollisResults: 0,
        totalOnlineArticles: 0,
        totalImages: 0,
        requestedSearchTerm: "",
        searchTermDisplay: ""
      });
    });
    _defineProperty(_this, "handleSearchTermChange", function (keyword) {
      _this.setState({
        searchTerm: keyword
      });
    });
    _defineProperty(_this, "handleSubmit", function () {
      var gcse = window.google.search.cse.element.getElement("google_cse");
      var keyword = _this.state.searchTerm;
      _this.setState({
        requestedSearchTerm: keyword
      });
      if (keyword.length > 0) {
        _this.state.queryString.keyword = keyword;
        if (gcse) {
          gcse.execute(keyword);
        }
        _this.getData(keyword);
        _this.updateUrl(keyword);
      } else {
        if (gcse) {
          gcse.clearAllResults();
        }
        _this.resetSearch();
      }
    });
    _defineProperty(_this, "getData", function (keyword) {
      // get images
      _this.getImageData(keyword).done(function (data) {
        if (keyword != _this.state.requestedSearchTerm) {
          return;
        }
        var results = data["SEGMENTS"]["JAGROOT"]["RESULT"];
        if (typeof results["DOCSET"] === "undefined") {
          _this.setState({
            totalImages: 0,
            featuredImages: [],
            searchTermDisplay: keyword
          });
          return;
        }
        var totalHits = parseInt(results["DOCSET"]["@TOTALHITS"]);
        var parsedData = [];
        if (totalHits != 0) {
          parsedData = _this.parseImageData(results["DOCSET"]["DOC"], keyword).slice(0, 4);
        }
        _this.setState({
          totalImages: totalHits,
          featuredImages: parsedData
        });
      }).fail(function (xhr, status, error) {
        _this.setState({
          totalImages: 0,
          featuredImages: [],
          searchTermDisplay: keyword
        });
      });

      // Hollis everything results
      _this.getHollisData(keyword).done(function (data) {
        if (keyword != _this.state.requestedSearchTerm) {
          return;
        }
        var results = data["SEGMENTS"]["JAGROOT"]["RESULT"];
        if (typeof results["DOCSET"] === "undefined") {
          _this.setState({
            totalHollisResults: 0,
            hollisResults: [],
            searchTermDisplay: keyword
          });
          return;
        }
        var totalHits = parseInt(results["DOCSET"]["@TOTALHITS"]);
        var parsedData = [];
        if (totalHits != 0) {
          parsedData = _this.parseListingData(results["DOCSET"]["DOC"], keyword);
        }
        _this.setState({
          totalHollisResults: totalHits,
          hollisResults: parsedData,
          searchTermDisplay: keyword
        });
      }).fail(function (xhr, status, error) {
        _this.setState({
          totalHollisResults: 0,
          hollisResults: [],
          searchTermDisplay: keyword
        });
      });

      // Get Articles
      _this.getArticleData(keyword, [{
        type: "rtype",
        values: ["articles"]
      }, {
        type: "tlevel",
        values: ["online_resources"]
      }, {
        type: "tlevel",
        values: ["peer_reviewed"]
      }]).done(function (data) {
        if (keyword != _this.state.requestedSearchTerm) {
          return;
        }
        var results = data["SEGMENTS"]["JAGROOT"]["RESULT"];
        if (typeof results["DOCSET"] === "undefined") {
          return;
        }
        var totalHits = parseInt(results["DOCSET"]["@TOTALHITS"]);
        var parsedData = [];
        if (totalHits != 0) {
          parsedData = _this.parseListingData(results["DOCSET"]["DOC"], keyword);
        }
        _this.setState({
          totalOnlineArticles: totalHits,
          onlineArticles: parsedData,
          searchTermDisplay: keyword
        });
      });
    });
    _defineProperty(_this, "getFeaturedLibrary", function (id) {
      return _jquery["default"].ajax({
        url: "/api/v1/library/".concat(id, "?_format=json"),
        // 131 - cabot
        data: null,
        timeout: 10000,
        dataType: "json"
      });
    });
    _defineProperty(_this, "getHollisData", function (keyword) {
      var _this$props = _this.props,
        searchRequest = _this$props.searchRequest,
        baseRequestUrl = _this$props.baseRequestUrl;
      var query = "query=any,contains," + encodeURIComponent(keyword);
      var queryUrl = "".concat(baseRequestUrl, "?institution=HVD&").concat(query, "&bulkSize=10&indx=").concat(searchRequest.page, "&lang=eng&loc=local,scope:(HVD)&loc=adaptor,primo_central_multiple_fe&json=true&pcAvailability=true&onCampus=true");
      return _jquery["default"].ajax({
        url: queryUrl,
        data: null,
        timeout: 10000,
        dataType: "jsonp"
      });
    });
    _defineProperty(_this, "getArticleData", function (keyword) {
      var optionalFacets = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
      var _this$props2 = _this.props,
        searchRequest = _this$props2.searchRequest,
        baseRequestUrl = _this$props2.baseRequestUrl;
      var query = "query=any,contains," + encodeURIComponent(keyword);
      optionalFacets.forEach(function (facet) {
        query += "&query=facet_" + facet.type + ",exact," + encodeURIComponent(facet.values.join(" "));
      });
      var queryUrl = "".concat(baseRequestUrl, "?institution=HVD&").concat(query, "&bulkSize=10&indx=").concat(searchRequest.page, "&lang=eng&loc=local,scope:(HVD)&loc=adaptor,primo_central_multiple_fe&onCampus=true&json=true");
      return _jquery["default"].ajax({
        url: queryUrl,
        data: null,
        timeout: 10000,
        dataType: "jsonp"
      });
    });
    _defineProperty(_this, "getImageData", function (keyword) {
      var _this$props3 = _this.props,
        searchRequest = _this$props3.searchRequest,
        baseRequestUrl = _this$props3.baseRequestUrl;
      var query = "query=any,exact," + encodeURIComponent(_this.state.searchTerm);
      var queryUrl = "".concat(baseRequestUrl, "?institution=HVD&").concat(query, "&bulkSize=10&indx=").concat(searchRequest.page, "&sortField=").concat(searchRequest.sort, "&loc=local,scope:(HVD_VIA)&lang=eng&json=true");
      return _jquery["default"].ajax({
        url: queryUrl,
        data: null,
        timeout: 10000,
        dataType: "jsonp"
      });
    });
    _defineProperty(_this, "setActiveTab", function (index) {
      if (index != _this.state.activeTabIndex) {
        _this.setState({
          activeTabIndex: index
        });
      }
    });
    return _this;
  }
  _inherits(SearchListingApp, _Component);
  return _createClass(SearchListingApp, [{
    key: "updateUrl",
    value: function updateUrl() {
      var stringifiedQueries = _queryString["default"].stringify(this.state.queryString);
      var newUrl = window.location.protocol + "//" + window.location.host + window.location.pathname + "?" + stringifiedQueries;
      window.history.replaceState({
        path: newUrl
      }, "", newUrl);
    }
  }, {
    key: "parseListingData",
    value: function parseListingData(data) {
      var _this2 = this;
      var keyword = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
      var results = Array.isArray(data) ? data : [data];
      return results.map(function (result) {
        var record = result.PrimoNMBib.record;
        var display = record.display;
        var addata = record.addata;
        var linkData = _this2.createLink(result, keyword);
        var author = addata.au ? squashArray(addata.au) : addata.aucorp ? squashArray(addata.aucorp) : "";
        var type = display.type ? squashArray(display.type) : "";
        var publisher = display.publisher ? squashArray(display.publisher) : "";
        publisher = display.edition ? publisher + ", " + squashArray(display.edition) : publisher;
        publisher = display.lds19 ? publisher + " " + squashArray(display.lds19) : publisher;
        return {
          title: display.title ? squashArray(display.title) : "",
          href: linkData.recordLink,
          isPartOf: display.ispartof ? squashArray(display.ispartof) : "",
          id: result.PrimoNMBib.record.control.recordid,
          type: type,
          link: linkData.buttonLink,
          additionaLink: linkData.additionalLink,
          publisher: publisher,
          author: author
        };
      });
      function squashArray(value) {
        return Array.isArray(value) ? value.join(" ") : value;
      }
    }
  }, {
    key: "parseImageData",
    value: function parseImageData(data, keyword) {
      var _this3 = this;
      var results = Array.isArray(data) ? data : [data];
      return results.map(function (result) {
        var restricted = result.PrimoNMBib.record.addata.mis1 ? result.PrimoNMBib.record.addata.mis1.includes('restrictedImage="true"') : false;
        var thumbnail = result.LINKS.thumbnail || "";
        if (Array.isArray(result.LINKS.thumbnail)) {
          thumbnail = result.LINKS.thumbnail[0];
        }

        // restricted images will only render in the 150 x 150 aspect ratio
        if (!restricted) {
          thumbnail = thumbnail.replace(/=150/gi, "=270");
        }
        return {
          title: result.PrimoNMBib.record.display.title,
          thumbnail: thumbnail,
          id: result.PrimoNMBib.record.control.recordid,
          link: _this3.createLink(result, keyword).buttonLink,
          restricted: restricted
        };
      }).filter(function (result) {
        return result.thumbnail.startsWith("http");
      });
    }
  }, {
    key: "createLink",
    value: function createLink(result, keyword) {
      var id = result.PrimoNMBib.record.control.recordid;
      var searchTerm = encodeURIComponent(keyword);
      var category = result.PrimoNMBib.record.delivery.delcategory;
      var validOpenUrl = typeof result.LINKS.linktorsrc === "string" || typeof result.LINKS.openurl === "string";
      var baseUrl = "https://hollis.harvard.edu/primo-explore/fulldisplay?docid=".concat(id, "&vid=HVD2&lang=en_US&search_scope=everything&query=any,contains,").concat(searchTerm);
      return {
        recordLink: baseUrl,
        buttonLink: function () {
          if (category === "Remote Search Resource" && validOpenUrl) {
            return {
              href: result.LINKS.linktorsrc || result.LINKS.openurl,
              text: "View online"
            };
          } else {
            return {
              href: baseUrl,
              text: "Find it at Harvard"
            };
          }
        }(),
        additionalLink: null // additional link removed
      };
    }
  }, {
    key: "renderIconPromos",
    value: function renderIconPromos(iconPromos) {
      return iconPromos.map(function (iconPromo, i) {
        return /*#__PURE__*/_react["default"].createElement(_iconPromo["default"], _extends({
          key: i
        }, iconPromo));
      });
    }
  }, {
    key: "render",
    value: function render() {
      var iconPromos = this.props.iconPromos;
      var _this$state = this.state,
        featuredLibrary = _this$state.featuredLibrary,
        featuredImages = _this$state.featuredImages,
        hollisResults = _this$state.hollisResults,
        onlineArticles = _this$state.onlineArticles,
        searchTermDisplay = _this$state.searchTermDisplay,
        totalHollisResults = _this$state.totalHollisResults,
        totalImages = _this$state.totalImages,
        totalOnlineArticles = _this$state.totalOnlineArticles,
        activeTabIndex = _this$state.activeTabIndex,
        filters = _this$state.filters;
      var button = {
        text: "Search",
        type: "submit",
        size: "small",
        theme: "inline"
      };
      var hollisButton = {
        href: "https://hollis.harvard.edu/primo-explore/search?query=any,contains,".concat(encodeURIComponent(searchTermDisplay), "&search_scope=everything&vid=HVD2"),
        info: "view more results on Hollis for ".concat(searchTermDisplay),
        text: "more from hollis",
        type: "button",
        size: "",
        theme: "secondary",
        outline: false,
        cssClass: ""
      };
      var articlesButton = {
        href: "https://hollis.harvard.edu/primo-explore/search?query=any,contains,".concat(encodeURIComponent(searchTermDisplay), "&search_scope=everything&vid=HVD2&mfacet=rtype,include,articles,1"),
        info: "view more results on Hollis for ".concat(searchTermDisplay),
        text: "more from hollis",
        type: "button",
        size: "",
        theme: "secondary",
        outline: false,
        cssClass: ""
      };
      var seeMoreImages = "https://images.hollis.harvard.edu/primo-explore/search?query=any,contains,".concat(encodeURIComponent(searchTermDisplay), "&tab=default_tab&search_scope=default_scope&vid=HVD_IMAGES&lang=en_US&offset=0");
      return /*#__PURE__*/_react["default"].createElement("section", {
        className: "hl__search-listing"
      }, /*#__PURE__*/_react["default"].createElement("header", {
        className: "hl__search-listing__header"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "hl__search-listing__container"
      }, /*#__PURE__*/_react["default"].createElement("h1", {
        className: "hl__search-listing__title"
      }, /*#__PURE__*/_react["default"].createElement("span", null, "Beta"), " Search Results"), /*#__PURE__*/_react["default"].createElement("div", {
        className: "hl__search-listing__search-input"
      }, /*#__PURE__*/_react["default"].createElement(_singleInputForm["default"], {
        onSubmit: this.handleSubmit,
        onChange: this.handleSearchTermChange,
        action: "#",
        theme: "clear",
        button: button,
        searchTerm: this.state.searchTerm
      }), /*#__PURE__*/_react["default"].createElement("div", {
        className: "hl__search-listing__input-helper"
      }, /*#__PURE__*/_react["default"].createElement("span", null, "We're working to build a more helpful search experience."), /*#__PURE__*/_react["default"].createElement("a", {
        className: "hl__link-tag",
        href: "/about/news/2018-01-26/building-better-library-search-experience"
      }, "Read our vision for search."))))), /*#__PURE__*/_react["default"].createElement("main", {
        className: "hl__search-listing__main-content"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "hl__search-listing__filters"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "hl__search-listing__container"
      }, /*#__PURE__*/_react["default"].createElement(_filterByType["default"], _extends({
        activeFilter: activeTabIndex,
        onChange: this.setActiveTab
      }, filters)), /*#__PURE__*/_react["default"].createElement("div", {
        className: "hl__search-listing__more-filters"
      }, /*#__PURE__*/_react["default"].createElement("span", null, "More options coming soon!\xA0"), " ", /*#__PURE__*/_react["default"].createElement("a", {
        href: "https://harvard.az1.qualtrics.com/jfe/form/SV_em721xdnn2Kg6xL?Source=BetaSearch",
        className: "hl__link-tag"
      }, "What would you like to see?")))), /*#__PURE__*/_react["default"].createElement("div", {
        className: "hl__search-listing__results-container"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "hl__search-listing__images " + (activeTabIndex === "0" && featuredImages.length ? "is-active" : "")
      }, /*#__PURE__*/_react["default"].createElement(_featuredImageList["default"], {
        featuredImages: featuredImages,
        totalImages: totalImages,
        seeMoreLink: seeMoreImages
      })), /*#__PURE__*/_react["default"].createElement("div", {
        className: "hl__search-listing__results"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "hl__search-listing__result " + (activeTabIndex === "0" ? "is-active" : "")
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "hl__search-listing__result-details"
      }, "Showing ", /*#__PURE__*/_react["default"].createElement("b", null, hollisResults.length), " of ", /*#__PURE__*/_react["default"].createElement("b", null, totalHollisResults), " HOLLIS results for ", /*#__PURE__*/_react["default"].createElement("b", null, "\"", searchTermDisplay, "\"")), /*#__PURE__*/_react["default"].createElement(_resultsList["default"], {
        results: hollisResults,
        searchTerm: searchTermDisplay,
        totalResults: totalHollisResults
      }), hollisResults.length > 0 && /*#__PURE__*/_react["default"].createElement("div", {
        className: "hl__search-listing__more-button"
      }, /*#__PURE__*/_react["default"].createElement(_button["default"], hollisButton))), /*#__PURE__*/_react["default"].createElement("div", {
        className: "hl__search-listing__result " + (activeTabIndex === "1" ? "is-active" : "")
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "hl__search-listing__result-details"
      }, "Showing ", /*#__PURE__*/_react["default"].createElement("b", null, onlineArticles.length), " of ", /*#__PURE__*/_react["default"].createElement("b", null, totalOnlineArticles), " Online Articles results for ", /*#__PURE__*/_react["default"].createElement("b", null, "\"", searchTermDisplay, "\"")), /*#__PURE__*/_react["default"].createElement(_resultsList["default"], {
        results: onlineArticles,
        searchTerm: searchTermDisplay,
        totalResults: totalOnlineArticles
      }), onlineArticles.length > 0 && /*#__PURE__*/_react["default"].createElement("div", {
        className: "hl__search-listing__more-button"
      }, /*#__PURE__*/_react["default"].createElement(_button["default"], articlesButton))), /*#__PURE__*/_react["default"].createElement("div", {
        className: "hl__search-listing__result " + (activeTabIndex === "2" ? "is-active" : "")
      }, /*#__PURE__*/_react["default"].createElement("div", {
        id: "hl__google-cse-results"
      }))), /*#__PURE__*/_react["default"].createElement("div", {
        className: "hl__search-listing__sidebar"
      }, featuredLibrary && /*#__PURE__*/_react["default"].createElement("div", {
        className: "hl__search-listing__featured-library"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "hl__search-listing__library-title"
      }, "Featured Library"), /*#__PURE__*/_react["default"].createElement(_libraryCard["default"], featuredLibrary)), this.renderIconPromos(iconPromos)))));
    }
  }]);
}(_react.Component);
_defineProperty(SearchListingApp, "propTypes", {
  searchRequest: (0, _propTypes.shape)({
    page: _propTypes.number.isRequired,
    sort: _propTypes.string.isRequired
  }),
  baseRequestUrl: _propTypes.string.isRequired,
  baseImageRequestUrl: _propTypes.string.isRequired,
  featuredImages: _propTypes.array,
  hollisResults: _propTypes.array,
  onlineArticles: _propTypes.array,
  featuredLibrary: _propTypes.object,
  iconPromos: _propTypes.array
});
_defineProperty(SearchListingApp, "defaultProps", {
  searchRequest: {
    page: 1,
    sort: "" //relevance by default
  },
  baseRequestUrl: "",
  baseImageRequestUrl: "",
  featuredImages: [],
  hollisResults: [],
  onlineArticles: []
});

},{"../../01-atoms/buttons/button.jsx":1,"../../02-molecules/forms/filter-by-type.jsx":2,"../../02-molecules/forms/single-input-form.jsx":3,"../../02-molecules/teasers/icon-promo.jsx":4,"../../02-molecules/teasers/library-card.jsx":5,"../../03-organisms/lists/featured-image-list.jsx":7,"../../03-organisms/lists/results-list.jsx":8,"jquery":"jquery","prop-types":"prop-types","query-string":"query-string","react":"react"}],12:[function(require,module,exports){
"use strict";

var _react = _interopRequireDefault(require("react"));
var _reactDom = require("react-dom");
var _searchListingApp = _interopRequireDefault(require("./search-listing-app.jsx"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var el = document.querySelector(".js-search-listing-app");
if (el) {
  var harvardLibrary = window.harvardLibrary || {};
  var initialProps = {
    searchRequest: {
      page: 1,
      sort: "" //relevance by default
    },
    baseRequestUrl: el.getAttribute("data-request-url"),
    featuredImages: [],
    hollisResults: [],
    onlineArticles: [],
    featuredLibrary: null,
    iconPromos: harvardLibrary.iconPromos || null
  };
  var props = initialProps;
  (0, _reactDom.render)(/*#__PURE__*/_react["default"].createElement(_searchListingApp["default"], props), el);
}

},{"./search-listing-app.jsx":11,"react":"react","react-dom":"react-dom"}],13:[function(require,module,exports){
"use strict";

var _searchListing = _interopRequireDefault(require("../_patterns/04-templates/content-types/search-listing.js"));
var _searchDirectory = _interopRequireDefault(require("../_patterns/04-templates/content-types/search-directory.js"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }

},{"../_patterns/04-templates/content-types/search-directory.js":10,"../_patterns/04-templates/content-types/search-listing.js":12}]},{},[13]);
